import { Pipe, PipeTransform } from '@angular/core';
import { DurationInputArg2 } from 'moment';
import * as moment from 'moment';

const DEFAULT_DURATION_AMOUNT = 14;

@Pipe({
  name: 'expiresIn',
})
export class ExpiresInPipe implements PipeTransform {
  transform(
    value: string,
    thresholdNumber: number = DEFAULT_DURATION_AMOUNT,
    thresholdUnit: DurationInputArg2 = 'days'
  ): string {
    const expiresDate = moment
      .utc(new Date(value), 'YYYY-MM-DD H:m:s')
      .local()
      .add(thresholdNumber, thresholdUnit);
    const currentDate = moment(new Date());

    // If difference in days is greater than 1, display ceiling of days
    // If difference in hours is greater than 1, display ceiling of hours
    // If difference in hours is less than 1 hour, check for minutes; if it's below 1 minute mark it
    // Else display 1 hour
    if (Math.ceil(expiresDate.diff(currentDate, 'days', true)) > 1) {
      return Math.ceil(expiresDate.diff(currentDate, 'days', true)) + ' days';
    } else if (Math.ceil(expiresDate.diff(currentDate, 'hours', true)) > 1) {
      if (Math.ceil(expiresDate.diff(currentDate, 'hours', true)) === 24) {
        return '1 day';
      } else {
        return Math.ceil(expiresDate.diff(currentDate, 'hours', true)) + ' hours';
      }
    } else if (expiresDate.diff(currentDate, 'minutes', true) < 1) {
      return 'very soon!';
    } else {
      if (Math.ceil(expiresDate.diff(currentDate, 'minutes', true)) === 60) {
        return '1 hour';
      } else {
        return Math.ceil(expiresDate.diff(currentDate, 'minutes', true)) + ' minutes';
      }
    }
  }
}
